/**
 * Level Configuration
 * 
 * Defines the progression of difficulty through incremental levels.
 * Each level increases the number of rooms, making the Hamiltonian path
 * problem exponentially more difficult.
 */

import { Level } from './types';

export const LEVELS: Level[] = [
  {
    number: 1,
    numRooms: 4,
    name: 'Tutorial',
    description: 'Learn the basics with just 4 rooms. A gentle introduction to the puzzle.',
  },
  {
    number: 2,
    numRooms: 6,
    name: 'Beginner',
    description: '6 rooms to navigate. The complexity starts to grow.',
  },
  {
    number: 3,
    numRooms: 8,
    name: 'Intermediate',
    description: '8 rooms. Now you need to think ahead!',
  },
  {
    number: 4,
    numRooms: 10,
    name: 'Advanced',
    description: '10 rooms. The puzzle becomes significantly harder.',
  },
  {
    number: 5,
    numRooms: 12,
    name: 'Expert',
    description: '12 rooms. Only for the most strategic players.',
  },
  {
    number: 6,
    numRooms: 15,
    name: 'Master',
    description: '15 rooms. The exponential difficulty is real!',
  },
];

/**
 * Get level configuration by level number
 */
export const getLevel = (levelNumber: number): Level | undefined => {
  return LEVELS.find(level => level.number === levelNumber);
};

/**
 * Get the total number of levels
 */
export const getTotalLevels = (): number => {
  return LEVELS.length;
};

/**
 * Check if there is a next level
 */
export const hasNextLevel = (currentLevel: number): boolean => {
  return currentLevel < LEVELS.length;
};

/**
 * Format time in MM:SS format
 */
export const formatTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};